import poll from './poll';
import { trackPage } from './analytics-helper';

const validateFpti = () => {
  if (!window.fpti) {
    return Promise.reject(false);
  }
  return Promise.resolve(window.fpti);
};

// eslint-disable-next-line
const fireTrackEventWhenFptiIsReady = (options) => {
  const { retries = 10, delay = 500 } = options;

  // Let's filter out params the fpti track event doesn't need.
  const trackPageParams = Object.assign({}, options);
  delete trackPageParams.retries;
  delete trackPageParams.delay;

  return poll(validateFpti, retries, delay)
    .then(() => trackPage(trackPageParams))
    .catch(() => {});
};

export default fireTrackEventWhenFptiIsReady;
